import request from '@/utils/request'

export function getProtocolListApi() {
  return request({
    url: '/config-service/v1/statistic/code/code-base',
    method: 'get',
    params: { pCode: 'IPTV' }
  })
}

export function getListNation() {
  return request({
    url: '/config-service/v1/statistic/code/code-base',
    method: 'get',
    params: {
      pCode: 'NATION'
    }
  })
}

export function getListNationality() {
  return request({
    url: '/config-service/v1/statistic/code/code-base',
    method: 'get',
    params: {
      pCode: 'NATION'
      // pCode: 'NATIONALITY'
    }
  })
}

export function getListTravellerLevel() {
  return request({
    url: '/config-service/v1/statistic/code/code-base',
    method: 'get',
    params: {
      pCode: 'TRAVELLER_LEVEL'
    }
  })
}

export function getListProductType() {
  return request({
    url: '/config-service/v1/statistic/code/code-base',
    method: 'get',
    params: {
      pCode: 'PRODUCT_TYPE'
    }
  })
}

export function getListTarget() {
  return request({
    url: '/config-service/v1/statistic/code/code-base',
    method: 'get',
    params: {
      pCode: 'TARGET'
    }
  })
}
export function getBusinessTypeApi() {
  return request({
    url: '/config-service/v1/statistic/code/code-base',
    method: 'get',
    params: {
      pCode: 'BUSINESS_TYPE'
    }
  })
}

export function getCodeBase(query) {
  return request({
    url: '/config-service/v1/statistic/code/code-base',
    method: 'get',
    params: {
      pCode: query.p_code
    }
  })
}
